<template lang="pug">
    div(style="width:auto;height:70px")
        v-menu(v-model="menu" offset-y)
            template(v-slot:activator="{ on }")
                v-list-item(v-on="on" :style="styleUserPanel")
                    v-list-item-avatar(style="min-width:38px;overflow:hidden;" v-if="$store.state.userInfo.foto !== undefined")
                        v-img(v-if="$store.state.userInfo.foto == null" src="https://sisep.minedu.gob.bo/img/profile.png")
                        v-img(v-else :src="'https://sisep.minedu.gob.bo/db-service/db-service-oauth-acl/'+$store.state.userInfo.foto")
                    v-list-item-avatar(style="min-width:38px;overflow:hidden;" v-else)
                        v-img(src="https://sisep.minedu.gob.bo/img/profile.png")
                    v-list-item-content
                        v-list-item-title(style="text-transform:capitalize !important;") {{ $store.state.name_user }}
                    v-list-item-action
                        v-icon(v-if="!menu") fas fa-angle-down
                        v-icon(v-else) fas fa-angle-up
            v-card(width="350")
                v-card-text
                    v-layout(row,wrap)
                        v-flex(xs4,style="background-color:rgba(0,255,0,0);")
                            v-avatar(size="90" style="margin:3px;overflow:hidden;" v-if="$store.state.userInfo.foto !== undefined")
                                v-img(v-if="$store.state.userInfo.foto == null" src="https://sisep.minedu.gob.bo/img/profile.png")
                                v-img(v-else :src="'https://sisep.minedu.gob.bo/db-service/db-service-oauth-acl/'+$store.state.userInfo.foto")
                                a.changePhoto(@click="dialogoChangePhoto=true" style="color:#FFF") Cambiar
                            v-avatar(size="90",style="margin:3px;overflow:hidden;" v-else)
                                v-img(src="https://sisep.minedu.gob.bo/img/profile.png")
                                a.changePhoto(@click="dialogoChangePhoto=true" style="color:#FFF") Cambiar
                        v-flex(xs8)
                            h4.body-2(style="padding-left:5px;margin-top:20px;") {{ $store.state.user.username }}
                            h4.body-1.blue-grey--text.text--darken-1(style="padding-left:5px;margin-top:-4px;width:212px;word-wrap: break-word") {{ $store.state.user.email }}
                v-divider
                v-card-actions(class="grey lighten-4")
                    v-btn.txtn.cursorLink(style="border-radius:5px;" small color="primary" outlined @click="dialogoConfiguracion=true") Configurar cuenta
                    v-spacer
                    v-btn.txtn.cursorLink(style="border-radius:5px;" small color="primary" @click="logOut") Cerrar sesión
        v-dialog(v-model="dialogoChangePhoto" width="300")
            v-card(style="border-radius:5px;overflow:hidden;")
                v-card-text
                    h3.body-1 Disponible en la siguiente versión.
        v-dialog(v-model="dialogoConfiguracion" scrollable max-width="650px" persistent)
            v-card(style="border-radius:6px;overflow:hidden !important;")
                v-card-title.no-padding
                    v-app-bar.custom-tool-config(dense, flat, dark, color='primary')
                        v-icon fas fa-user-cog
                        v-toolbar-title(style="font-size:15px;margin-left:10px;") Configuración
                        v-spacer
                        v-btn(icon, dark, @click="dialogoConfiguracion=false")
                            v-icon fas fa-times
                v-divider
                v-card-text.no-padding(style="height:370px")
                    v-card.pb-3(flat v-if="bottomNav=='general'")
                        v-card-text.pa-2
                            p.body-2.blue--text.text--darken-1.text-xs-center.pt-2 CONFIGURACIÓN GENERAL
                            v-card(style="border-radius:6px;")
                                v-card-text
                                    p.body-2.no-padding.no-margin Modificar correo electrónico:
                                    p.body-2.font-italic.no-padding.no-margin Correo actual:&nbsp;
                                        span.blue--text.text--darken-1 G.232215@sisep.com
                                    v-text-field(prepend-icon="fas fa-envelope" label="Nuevo correo electrónico" hide-details color="blue darken-1")
                                v-card-actions
                                    p.caption.font-italic.blue--text.text--darken-1.pl-2(style="line-height:14px;") Se requiere confirmación <br> vía mensaje de correo electrónico
                                    v-spacer
                                    v-btn(color="green" dark style="border-radius:5px;" @click="changePassword") Confirmar cambio de correo
                    v-card.pb-3(flat v-else-if="bottomNav=='password'")
                        v-card-text.pa-2
                            p.body-2.blue--text.text--darken-1.text-xs-center.pt-2 CONFIGURACIÓN DE CONTRASEÑA
                            v-card(style="border-radius:6px;")
                                v-card-text
                                    p.body-2.no-padding.no-margin Modificar contraseña:
                                    v-text-field.pb-3(prepend-icon="fas fa-key" v-model="currentPassword" label="Contraseña actual" hide-details :append-icon="showCurrentPassword ? 'fas fa-eye' : 'fas fa-eye-slash'", :type="showCurrentPassword ? 'password' : 'text'", @click:append="changeCurrentPassword" ref="refCurrentPassword" color="blue darken-1")
                                    v-text-field.pb-3(prepend-icon="fas fa-key" v-model="newPassword" label="Nueva contraseña" hide-details :append-icon="showNewPassword ? 'fas fa-eye' : 'fas fa-eye-slash'", :type="showNewPassword ? 'password' : 'text'", @click:append="changeNewPassword" ref="refNewPassword" color="blue darken-1")
                                    v-text-field(prepend-icon="fas fa-key" v-model="confirmNewPassword" label="Confirmar nueva contraseña" hide-details :append-icon="showConfirmNewPassword ? 'fas fa-eye' : 'fas fa-eye-slash'", :type="showConfirmNewPassword ? 'password' : 'text'", @click:append="changeConfirmNewPassword" ref="refConfirmNewPassword" color="blue darken-1", v-on:keyup.enter="changePassword")
                                v-card-actions
                                    v-spacer
                                    v-btn.txtn(color="green" dark style="border-radius:5px;" @click="changePassword" :loading="isPasswordLoading") Guardar Cambios
                    v-card.pb-3(flat v-else)
                        v-card-text
                            p.body-2.blue--text.text--darken-1.text-xs-center.pt-2 ACTIVIDAD DE CUENTA
                            v-timeline(align-top, dense style="margin-top:-30px;")
                                v-timeline-item(color='green darken-1' small)
                                    v-layout(pt-3)
                                        v-flex(xs3)
                                            strong 02/06/2019
                                        v-flex(xs2).primary--text
                                            strong 4:38 pm
                                        v-flex
                                            span Inicio de sesión
                                v-timeline-item(color='red darken-1' small)
                                    v-layout(pt-3)
                                        v-flex(xs3)
                                            strong 01/06/2019
                                        v-flex(xs2).primary--text
                                            strong 7:25 pm
                                        v-flex
                                            span Cierre de sesión
                                v-timeline-item(color='red darken-1' small)
                                    v-layout(pt-3)
                                        v-flex(xs3)
                                            strong 01/06/2019
                                        v-flex(xs2).primary--text
                                            strong 5:12 pm
                                        v-flex
                                            span Bloqueo de sesión por inactividad
                                v-timeline-item(color='primary' small)
                                    v-layout(pt-3)
                                        v-flex(xs3)
                                            strong 12/13/2019
                                        v-flex(xs2).primary--text
                                            strong 4:38 pm
                                        v-flex
                                            span Modificación de contraseña
                                v-timeline-item(color='green darken-1' small)
                                    v-layout(pt-3)
                                        v-flex(xs3)
                                            strong 22/05/2019
                                        v-flex(xs2).primary--text
                                            strong 4:38 pm
                                        v-flex
                                            span Inicio de sesión
                                v-timeline-item(color='red darken-1' small)
                                    v-layout(pt-3)
                                        v-flex(xs3)
                                            strong 22/05/2019
                                        v-flex(xs2).primary--text
                                            strong 11:02 am
                                        v-flex
                                            span Cierre de sesión
                                v-timeline-item(color='green darken-1' small)
                                    v-layout(pt-3)
                                        v-flex(xs3)
                                            strong 12/13/2019
                                        v-flex(xs2).primary--text
                                            strong 9:11 am
                                        v-flex
                                            strong Inicio de sesión
                                v-timeline-item(color='red darken-1' small)
                                    v-layout(pt-3)
                                        v-flex(xs3)
                                            strong 12/13/2019
                                        v-flex(xs2)
                                            strong 5:12 pm
                                        v-flex
                                            strong Cierre de sesión
                                v-timeline-item(color='green darken-1' small)
                                    v-layout(pt-3)
                                        v-flex(xs3)
                                            strong 12/13/2019
                                        v-flex(xs2)
                                            strong 9:11 am
                                        v-flex
                                            strong Inicio de sesión
                                v-timeline-item(color='red darken-1' small)
                                    v-layout(pt-3)
                                        v-flex(xs3)
                                            strong 12/13/2019
                                        v-flex(xs2)
                                            strong 5:12 pm
                                        v-flex
                                            strong Cierre de sesión
                v-divider
                v-card-actions(style="height:55px;")
                    v-bottom-navigation(v-model='bottomNav' absolute color="primary" horizontal)
                        //-v-btn(color='primary' value='general')
                            span Config. Gral.
                            v-icon fas fa-user-cog
                        v-btn(color='primary' text value='password')
                            span Contraseña
                            v-icon fas fa-key
                        //-v-btn(color='primary' value='activity')
                            span Actividad
                            v-icon fas fa-chart-line
</template>
<script>
export default {
    data: function(){
        return{
            menu: false,
            dialogoChangePhoto: false,
            dialogoConfiguracion: false,
            bottomNav: 'password',
            currentPassword: '',
            newPassword: '',
            confirmNewPassword: '',
            showCurrentPassword:true,
            showNewPassword:true,
            showConfirmNewPassword:true,
            isPasswordLoading: false
        }
    },
    computed:{
        styleUserPanel(){
            if(this.$store.state.windowSize.w<800){
                return "height:70px;width:70px;";
            }
            else{
                return "height:70px;";
            }
        }
    },
    methods:{
        logOut(){
            localStorage.clear()
            window.location.replace("/portada")
        },
        changeCurrentPassword(){
            this.showCurrentPassword = !this.showCurrentPassword;
            return this.$refs.refCurrentPassword.focus();
        },
        changeNewPassword(){
            this.showNewPassword = !this.showNewPassword;
            return this.$refs.refNewPassword.focus();
        },
        changeConfirmNewPassword(){
            this.showConfirmNewPassword = !this.showConfirmNewPassword;
            return this.$refs.refConfirmNewPassword.focus();
        },
        changePassword(){
            if (this.confirmNewPassword.length > 5) {
                if (this.confirmNewPassword === this.newPassword) {
                    return this.continueChangePassword();
                } else {
                    return this.$snotify.warning("Las contraseñas no coinciden.", "Sin procesar");
                }
            } else {
                return this.$snotify.warning("Las contraseñas son muy cortas", "Sin procesar");
            }
        },
        continueChangePassword(){
            this.isPasswordLoading = true;
            return axios({
                method: 'POST',
                url: '/db-service/db-service-oauth-acl/api/v2/change-password',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('auth')
                },
                data: {
                    'current-password': this.currentPassword,
                    'new-password': this.newPassword
                }
            }).then((function(response) {
                this.$snotify.success("La contraseña se modificó correctamente.", "Correcto !");
                this.isPasswordLoading = false;
                return this.dialogConfig = false;
            }).bind(this))["catch"]((function(error) {
                if (error.response.status === 400) {
                    this.$snotify.warning(String(error.response.data), "Sin procesar");
                } else {
                    this.$snotify.error("Sin respuesta del servidor");
                }
                return this.isPasswordLoading = false;
            }).bind(this));
        }
    }
}
</script>
